import * as pcp from '../store/productCategoryPage'
import * as userSelectors from '../store/user'

import * as track from '../track/category'
import {formatDateString, isItemSoldOut} from '../utils'
import {fsa, fsaPayload, gateAction} from './helpers'
import {STANDARD_DATE_FORMAT} from '../const'

// -- Actions
export const CATEGORY_PAGE_FILTERING = 'category page is currently filtering'
export const categoryPageFiltering = fsa(CATEGORY_PAGE_FILTERING)

export const CLEAR_EVENT_DATE = 'clear event date'
export const clearEventDate = fsa(CLEAR_EVENT_DATE)

export const CLOSE_EVENT_FILTER_DROPDOWN = 'close event date filter dropdown'
export const closeEventFilterDropdown = fsa(CLOSE_EVENT_FILTER_DROPDOWN)

export const CLOSE_PARTY_FILTER_DROPDOWN = 'close party filter dropdown'
export const closePartyFilterDropdown = fsa(CLOSE_PARTY_FILTER_DROPDOWN)

export const DISABLE_HTO_FILTER = 'turn off hto filter'
export const disableHtoFilter = fsa(DISABLE_HTO_FILTER)

export const ENABLE_EVENT_DATE_FILTER = 'event date filter has been enabled'
export const enableEventDateFilter = fsa(ENABLE_EVENT_DATE_FILTER)

export const ENABLE_HTO_FILTER = 'filter category by hto products'
export const enableHtoFilter = fsa(ENABLE_HTO_FILTER)

export const ENABLE_GROUP_PARTY_FILTER = 'enable group party renter filter'
export const enableGroupFilter = fsa(ENABLE_GROUP_PARTY_FILTER)

export const ENABLE_INDIVIDUAL_PARTY_FILTER = 'enable individual party renter filter'
export const enableIndividualFilter = fsa(ENABLE_INDIVIDUAL_PARTY_FILTER)

export const FILTER_SUCCESS = 'category page is finished filtering'
export const filterSuccess = fsaPayload(FILTER_SUCCESS)

export const OPEN_EVENT_FILTER_DROPDOWN = 'open event date filter dropdown'
export const openEventFilterDropdown = fsa(OPEN_EVENT_FILTER_DROPDOWN)

export const OPEN_FILTER_MODAL = 'open mobile category filter modal'
export const openFilterModal = fsa(OPEN_FILTER_MODAL)

export const OPEN_PARTY_FILTER_DROPDOWN = 'open party filter dropdown'
export const openPartyFilterDropdown = fsa(OPEN_PARTY_FILTER_DROPDOWN)

export const RESET_ALL_FILTERS = 'reset all category page filters to default'
export const resetAllFilters = fsa(RESET_ALL_FILTERS)

export const TOGGLE_HTO_FILTER = 'toggle hto filter'
export const toggleHtoFilter = fsa(TOGGLE_HTO_FILTER)

export const SELECT_EVENT_DATE = 'select event date on calendar'
export const selectEventDate = fsaPayload(SELECT_EVENT_DATE)

export const SELECT_PARTY_RADIO_INDIVIDUAL = 'select party filter individual radio button'
export const selectPartyIndividual = fsa(SELECT_PARTY_RADIO_INDIVIDUAL)

export const SELECT_PARTY_RADIO_GROUP = 'select party filter group radio button'
export const selectPartyGroup = fsa(SELECT_PARTY_RADIO_GROUP)

export const FILTER_BY_BUY_ONLY = 'only show products available for buy'
export const filterByBuy = fsa(FILTER_BY_BUY_ONLY)

// -- Thunks

export const CLOSE_FILTER_MODAL = 'close mobile category filter modal'
export const _closeFilterModal = fsa(CLOSE_FILTER_MODAL)
export const closeFilterModal = gateAction(_closeFilterModal, pcp.filterModalIsOpen)

// -- Helpers
export const categoryFilterFunnel = () => (dispatch, getState) => {
  const state = getState()
  dispatch(categoryPageFiltering())
  let categoryItems = pcp.categoryItems(state)
  const eventDate = pcp.currentEventDateFilter(state)
  const isBuyFilterActive = pcp.isFilterByBuyActive(state)

  if (pcp.isFilteredByHto(state)) {
    categoryItems = categoryItems.filter((item) => item.product_set.is_hto)
    track.categoryFiltered(
      pcp.categoryName(state),
      'HTO',
      pcp.categoryName(state),
      categoryItems.length,
    )
  }
  if (pcp.isFilteredByGroup(state)) {
    categoryItems = categoryItems.filter((item) => item.product_set.is_party_available)
    track.categoryFiltered(
      pcp.categoryName(state),
      'Rental Type',
      pcp.categoryName(state),
      categoryItems.length,
    )
  }
  if (eventDate) {
    const buyAppliedDate = formatDateString(new Date(), STANDARD_DATE_FORMAT)
    const rentalAppliedDate = formatDateString(eventDate, STANDARD_DATE_FORMAT)
    categoryItems = categoryItems.filter(({product_set: productSet}) => {
      const {
        buy_soldout_period_list: buySoldOutPeriodList,
        rent_soldout_period_list: rentSoldOutPeriodList,
        is_purchasable: isPurchasable,
      } = productSet

      const isBuySoldOut = isItemSoldOut(buyAppliedDate, buySoldOutPeriodList)
      const isRentalSoldOut = isItemSoldOut(rentalAppliedDate, rentSoldOutPeriodList)

      // We need to check both the availability and if the item is purchasable.
      const isBuyUnavailable = isBuySoldOut || !isPurchasable

      return !isRentalSoldOut || !isBuyUnavailable
    })

    const isDefaultDateChanged = pcp.isEventFilterApplied(state)
    track.categoryFiltered(
      pcp.categoryName(state),
      'Event Date',
      pcp.categoryName(state),
      categoryItems.length,
      isDefaultDateChanged,
    )
  }
  if (isBuyFilterActive) {
    categoryItems = categoryItems.filter((item) => item.product_set.is_purchasable)
  }
  setTimeout(() => {
    dispatch(filterSuccess(categoryItems))
  }, 700)
}

export const filterByEventDate = () => (dispatch, getState) => {
  const state = getState()
  if (pcp.filterSuccess(state) && pcp.displayedCategory(state)) {
    dispatch(enableEventDateFilter())
    dispatch(categoryFilterFunnel())
  }
}

export const filterByPartyType = (filter) => (dispatch, getState) => {
  const state = getState()
  if (pcp.filterSuccess(state)) {
    if (filter === 'Individual') {
      dispatch(enableIndividualFilter())
    } else {
      dispatch(enableGroupFilter())
    }
    dispatch(categoryFilterFunnel())
  }
}

export const clearDates = () => (dispatch) => {
  dispatch(clearEventDate())
  dispatch(categoryFilterFunnel())
}

export const resetFilters = () => (dispatch, getState) => {
  const state = getState()

  dispatch(resetAllFilters())

  // The filter funnel will be fired for authenticated users as part of setEventDateFilterDefault
  // The conditional here is to prevent the filtering from happening twice when resetting
  if (!userSelectors.isAuthenticated(state)) {
    dispatch(categoryFilterFunnel())
  }
}
export const filterByBuyOnly = () => (dispatch, getState) => {
  const state = getState()
  if (pcp.filterSuccess(state) && pcp.displayedCategory(state)) {
    dispatch(filterByBuy())
    dispatch(categoryFilterFunnel())
  }
}
export const SET_EVENT_DATE_FILTER_DEFAULT = 'pcp/set event date filter default'
export const setEventDateFilterDefault = fsa(SET_EVENT_DATE_FILTER_DEFAULT)
